import { PRIMARY } from '../../styles';

export default {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PRIMARY,
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
    height: '100vh',
  },
  paper: {
    padding: 30,
  },
  button: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Authentication/VerifyEmail/styles.js